module.exports = __webpack_public_path__ + "img/powered-by-dark.b2f49fb3.svg";